import http from '@/utils/http'

export function fetchRegions(params) {
	return http.get("/api/weixin/regions", {
		params: params
	});
}

export function regionSales(regionId) {
	return http.get("/api/weixin/regionSales/" + regionId);
}

export function regionDocs(regionId, type) {
	return http.get("/api/weixin/regionDocs/" + regionId, {
		params: {
			type: type
		}
	});
}

export function mapRegions(params) {
	return http.get("/api/weixin/mapRegions", {
		params: params
	});
}

export function divisions(params) {
	return http.get("/api/weixin/divisions", {
		params: params
	});
}

export function fetchNoticeBars() {
	return http.get("/api/weixin/noticeBars");
}

export function fetchRegionById(regionId) {
	return http.get("/api/weixin/region/" + regionId);
}